export default __webpack_public_path__ + "static/media/Edit2.10ef52bb.svg";